const GENDERS = {
  MENS: 'mens',
  WOMENS: 'womens',
  UNISEX: 'unisex',
};

const FORMATTED_GENDERS = {
  MENS: "Men's",
  WOMENS: "Women's",
  UNISEX: 'Unisex',
};

const TYPES = {
  SHOES: 'Shoes',
  ACCESSORIES: 'Accessories',
  SOCKS: 'Socks',
  UNDERWEAR: 'Underwear',
  APPAREL: 'Apparel',
  GIFT_CARDS: 'Gift Cards',
};

const EDITIONS = {
  CLASSIC: 'classic',
  LIMITED: 'limited',
  THROWBACK: 'throwback',
  EARTH_DAY: 'earthDay',
  SOCIAL: 'social',
  DEALS: 'deals',
  GRAPHIC: 'graphic',
  THREE_PACKS: '3Packs',
};

const SILHOUETTES = {
  RUNNER: 'runner',
  LOUNGER: 'lounger',
  ZEFFER: 'zeffer',
  SKIPPER: 'skipper',
  TOPPER: 'topper',
  BREEZER: 'breezer',
  DASHER: 'dasher',
};

const SIZING_TYPES = {
  HALF: 'HALF',
  WHOLE: 'WHOLE',
  SOCKS: 'SOCKS',
};

const SIZE_CODES = {
  SOCKS: {
    UNISEX: {
      SMALL: '01',
      MEDIUM: '02',
      LARGE: '03',
      EXTRA_LARGE: '04',
    },
  },
  SHOES: {
    MENS: {
      7: '070',
      7.5: '075',
      8: '080',
      8.5: '085',
      9: '090',
      9.5: '095',
      10: '100',
      10.5: '105',
      11: '110',
      11.5: '115',
      12: '120',
      12.5: '125',
      13: '130',
      13.5: '135',
      14: '140',
    },
    WOMENS: {
      5: '050',
      5.5: '055',
      6: '060',
      6.5: '065',
      7: '070',
      7.5: '075',
      8: '080',
      8.5: '085',
      9: '090',
      9.5: '095',
      10: '100',
      10.5: '105',
      11: '110',
    },
  },
};

const MASTER_PRODUCTS = {
  MENS_WOOL_RUNNERS: 'MENS_WOOL_RUNNERS',
  MENS_WOOL_RUNNER_MIZZLES: 'MENS_WOOL_RUNNER_MIZZLES',
  MENS_WOOL_RUNNER_UP_MIZZLES: 'MENS_WOOL_RUNNER_UP_MIZZLES',
  MENS_WOOL_LOUNGERS: 'MENS_WOOL_LOUNGERS',
  MENS_TREE_RUNNERS: 'MENS_TREE_RUNNERS',
  MENS_TREE_LOUNGERS: 'MENS_TREE_LOUNGERS',
  MENS_TREE_SKIPPERS: 'MENS_TREE_SKIPPERS',
  MENS_TREE_TOPPERS: 'MENS_TREE_TOPPERS',
  MENS_TREE_DASHERS: 'MENS_TREE_DASHERS',
  MENS_SUGAR_ZEFFERS: 'MENS_SUGAR_ZEFFERS',
  MENS_ZEFFER_STRAPS: 'MENS_ZEFFER_STRAPS',
  MENS_RUNNER_INSOLES: 'MENS_RUNNER_INSOLES',
  MENS_LOUNGER_SKIPPER_INSOLES: 'MENS_LOUNGER_SKIPPER_INSOLES',
  WOMENS_WOOL_RUNNERS: 'WOMENS_WOOL_RUNNERS',
  WOMENS_WOOL_RUNNER_MIZZLES: 'WOMENS_WOOL_RUNNER_MIZZLES',
  WOMENS_WOOL_RUNNER_UP_MIZZLES: 'WOMENS_WOOL_RUNNER_UP_MIZZLES',
  WOMENS_WOOL_LOUNGERS: 'WOMENS_WOOL_LOUNGERS',
  WOMENS_TREE_RUNNERS: 'WOMENS_TREE_RUNNERS',
  WOMENS_TREE_LOUNGERS: 'WOMENS_TREE_LOUNGERS',
  WOMENS_TREE_SKIPPERS: 'WOMENS_TREE_SKIPPERS',
  WOMENS_TREE_TOPPERS: 'WOMENS_TREE_TOPPERS',
  WOMENS_TREE_BREEZERS: 'WOMENS_TREE_BREEZERS',
  WOMENS_TREE_DASHERS: 'WOMENS_TREE_DASHERS',
  WOMENS_SUGAR_ZEFFERS: 'WOMENS_SUGAR_ZEFFERS',
  WOMENS_ZEFFER_STRAPS: 'WOMENS_ZEFFER_STRAPS',
  WOMENS_RUNNER_INSOLES: 'WOMENS_RUNNER_INSOLES',
  WOMENS_LOUNGER_INSOLES: 'WOMENS_LOUNGER_INSOLES',
  WOMENS_BREEZER_INSOLES: 'WOMENS_BREEZER_INSOLES',
  SMALLBIRDS_WOOL_RUNNERS: 'SMALLBIRDS_WOOL_RUNNERS',
  RUNNER_LACE_KIT: 'RUNNER_LACE_KIT',
  DIGITAL_GIFT_CARD: 'DIGITAL_GIFT_CARD',
  PHYSICAL_GIFT_CARD: 'PHYSICAL_GIFT_CARD',
  PHYSICAL_GIFT_CARD_BOOKLET: 'PHYSICAL_GIFT_CARD_BOOKLET',
  SADIE_SHAVES_THE_DAY: 'SADIE_SHAVES_THE_DAY',
  BIRD_MASK: 'BIRD_MASK',
  TRINO_TUBERS: 'TRINO_TUBERS',
  TRINO_HIDERS: 'TRINO_HIDERS',
  TRINO_QUARTERS: 'TRINO_QUARTERS',
  TRINO_SPRINTERS: 'TRINO_SPRINTERS',
  FACE_MASK: 'FACE_MASK',
  MENS_TRINO_PUFFER: 'MENS_TRINO_PUFFER',
  WOMENS_TRINO_PUFFER: 'WOMENS_TRINO_PUFFER',
  MENS_WOOL_CARDI: 'MENS_WOOL_CARDI',
  WOMENS_WOOL_CARDI: 'WOMENS_WOOL_CARDI',
  MENS_WOOL_JUMPER: 'MENS_WOOL_JUMPER',
  WOMENS_WOOL_JUMPER: 'WOMENS_WOOL_JUMPER',
  MENS_TRINO_XO_TEE: 'MENS_TRINO_XO_TEE',
  WOMENS_TRINO_XO_TEE: 'WOMENS_TRINO_XO_TEE',
  SUGAR_ROVERS: 'SUGAR_ROVERS',
};

export {
  EDITIONS,
  GENDERS,
  SILHOUETTES,
  FORMATTED_GENDERS,
  TYPES,
  SIZING_TYPES,
  SIZE_CODES,
  MASTER_PRODUCTS,
};
